module.exports = __webpack_public_path__ + "media/images/flags/16/Canada-d7671303abeddc34a2a3a721adbd7a4f.png";